import { render, staticRenderFns } from "./CredentialCopyStorageSave.vue?vue&type=template&id=5298e47b&scoped=true&"
import script from "./CredentialCopyStorageSave.vue?vue&type=script&lang=js&"
export * from "./CredentialCopyStorageSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5298e47b",
  null
  
)

export default component.exports